'use client';

import { getOrCreateId } from '@repo/utils/static-ids';
import { useRef } from 'react';
import { useBranchedPageAction } from '@/features/shared/analytics/hooks/useBranchedPageAction';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
export function useExitModalCloseAction() {
  const activityIdRef = useRef('');
  const featureViewedActivityId = getOrCreateId(activityIdRef);
  const fireCloseAction = useBranchedPageAction({
    actionName: ANALYTICS_ACTION_NAME,
    actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    actionType: 'close',
    actionInput: 'exit',
    parentActivityId: featureViewedActivityId
  });
  return {
    featureViewedActivityId,
    fireCloseAction
  };
}